"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _clsx3 = _interopRequireDefault(require("clsx"));

var _qrcode = _interopRequireDefault(require("qrcode"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Person = _interopRequireDefault(require("@material-ui/icons/Person"));

var _Email = _interopRequireDefault(require("@material-ui/icons/Email"));

var _Phone = _interopRequireDefault(require("@material-ui/icons/Phone"));

var _List = _interopRequireDefault(require("@material-ui/core/List"));

var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));

var _ListItemIcon = _interopRequireDefault(require("@material-ui/core/ListItemIcon"));

var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _Print = _interopRequireDefault(require("@material-ui/icons/Print"));

var _FileCopy = _interopRequireDefault(require("@material-ui/icons/FileCopy"));

var _Wapp = require("wapplr-react/dist/common/Wapp");

var _getUtils = _interopRequireDefault(require("wapplr-react/dist/common/Wapp/getUtils"));

var _externalContext = _interopRequireDefault(require("configurator-studio-arkitekter-components/dist/common/components/App/externalContext"));

var _context2 = _interopRequireDefault(require("configurator-studio-arkitekter-components/dist/common/components/App/context"));

var _context3 = _interopRequireDefault(require("configurator-studio-arkitekter-components/dist/common/components/Post/context"));

var _withMaterial = require("configurator-studio-arkitekter-components/dist/common/components/Template/withMaterial");

var _Menu = _interopRequireDefault(require("configurator-studio-arkitekter-components/dist/common/components/Menu"));

var _context4 = _interopRequireDefault(require("../Configurator/context"));

var _utils = require("../Configurator/utils");

var _Home = _interopRequireDefault(require("../Home"));

var _Gallery = _interopRequireDefault(require("../Gallery"));

var _menu = _interopRequireDefault(require("../App/menu"));

var _materialStyle = _interopRequireDefault(require("./materialStyle"));

var _Layers = _interopRequireDefault(require("../Layers"));

//import Logo, {SA} from "configurator-studio-arkitekter-components/dist/common/components/Logo";
var style = require("./style_css.js")["default"];

var containers = {};

function Summary(props) {
  var _data$settings, _data$settings$summar, _data$settings2, _data$settings2$summa, _data$settings3, _data$settings3$basic, _data$settings4, _data$settings4$basic, _data$settings5, _data$settings5$proje, _data$settings6, _data$settings6$summa, _data$settings7, _data$settings7$proje, _data$settings8, _data$settings8$proje, _data$settings9, _data$settings9$proje, _data$settings10, _data$settings10$summ, _data$settings11, _data$settings11$summ, _data$settings12, _data$settings12$summ, _data$models, _model$collections, _data$models2, _model$gallery;

  var context = (0, _react.useContext)(_Wapp.WappContext);
  var appContext = (0, _react.useContext)(_context2["default"]);
  var postContext = (0, _react.useContext)(_context3["default"]);
  var configuratorContext = (0, _react.useContext)(_context4["default"]);
  var externalContext = (0, _react.useContext)(_externalContext["default"]);
  var _externalContext$exte = externalContext.externalSettings,
      externalSettings = _externalContext$exte === void 0 ? {} : _externalContext$exte;
  var wapp = context.wapp,
      req = context.req;
  var utils = (0, _getUtils["default"])(context);
  var materialStyle = props.materialStyle,
      _props$breakPoint = props.breakPoint,
      breakPoint = _props$breakPoint === void 0 ? 730 : _props$breakPoint;
  var menus = appContext.menus,
      routes = appContext.routes,
      labels = appContext.labels,
      storage = appContext.storage;
  var data = configuratorContext.data,
      translate = configuratorContext.translate;
  wapp.styles.use(style);
  var savedData = storage();
  var container = (0, _react.useRef)();

  if (!containers[wapp.globals.WAPP]) {
    containers[wapp.globals.WAPP] = {};
  }

  var initialState = typeof window !== "undefined" && window[wapp.config.appStateName] || {
    req: {
      timestamp: Date.now()
    }
  };
  var firstRender = utils.getGlobalState().req.timestamp === initialState.req.timestamp || wapp.target === "node";

  var _useState = (0, _react.useState)(Object.keys(savedData).filter(function (key) {
    return key.match("summary_menu");
  })),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      setMenuData = _useState2[1];

  var _useState3 = (0, _react.useState)(configuratorContext.configuration),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      configuration = _useState4[0],
      setConfiguration = _useState4[1];

  var _useState5 = (0, _react.useState)((0, _utils.getQueryString)(configuratorContext.configuration)),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      queryString = _useState6[0],
      setQueryString = _useState6[1];

  var _useState7 = (0, _react.useState)(!firstRender && typeof window !== "undefined" && containers[wapp.globals.WAPP].current ? containers[wapp.globals.WAPP].current.offsetWidth < breakPoint : false),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      narrow = _useState8[0],
      _setNarrow = _useState8[1];

  var _useState9 = (0, _react.useState)(null),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      QRCodeUrl = _useState10[0],
      setQRCodeUrl = _useState10[1];

  (0, _react.useEffect)(function (menuData) {
    setMenuData(menuData);
  }, [Object.keys(storage()).filter(function (key) {
    return key.match("summary_menu");
  })]);
  (0, _react.useEffect)(function () {
    setConfiguration(configuratorContext.configuration);
    setQueryString((0, _utils.getQueryString)(configuratorContext.configuration));
  }, [configuratorContext.configuration]);

  var generateAndSetQRCode = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(text) {
      var qr;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _qrcode["default"].toDataURL(text, {
                quality: 1
              });

            case 3:
              qr = _context.sent;
              setQRCodeUrl(qr);
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function generateAndSetQRCode(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    var url = externalSettings !== null && externalSettings !== void 0 && externalSettings.parentUrl ? externalSettings.parentUrl + routes.summaryRoute : req.wappRequest.protocol + "://" + req.wappRequest.hostname + req.wappRequest.path;
    var copyUrl = url + "/" + queryString;

    if (externalSettings.summaryConfigurationUrl) {
      copyUrl = externalSettings.summaryConfigurationUrl({
        queryString: queryString
      });
    }

    generateAndSetQRCode(copyUrl.replace("localhost", "192.168.1.136"));
  }, [queryString]);
  (0, _react.useEffect)(function didMount() {
    function setNarrow(value) {
      if (narrow !== value) {
        _setNarrow(value);
      }
    }

    function onResize() {
      if (container.current) {
        if (container.current.offsetWidth > breakPoint) {
          setNarrow(false);
        } else {
          setNarrow(true);
        }
      } else {
        if (window.innerWidth > breakPoint) {
          setNarrow(false);
        } else {
          setNarrow(true);
        }
      }
    }

    function addResizeListeners() {
      if (container.current && typeof ResizeObserver !== "undefined") {
        var resizeObserver = new ResizeObserver(function (entries) {
          onResize(entries);
        });
        resizeObserver.observe(container.current);
        return function removeEventListener() {
          resizeObserver.disconnect();
        };
      } else {
        window.addEventListener("resize", onResize);
        return function removeEventListener() {
          window.removeEventListener("resize", onResize);
        };
      }
    }

    var removeResizeListeners = addResizeListeners();
    onResize();
    return function willUnmount() {
      removeResizeListeners();
    };
  }, [narrow, breakPoint, wapp.globals.WAPP]);
  var menu = (0, _menu["default"])({
    context: context,
    postContext: postContext,
    appContext: appContext,
    configuratorContext: configuratorContext,
    showPrice: true
  }).slice(1);
  var firstStepN = 0;
  menu.map(function (m, i) {
    var _m$items;

    if ((_m$items = m.items) !== null && _m$items !== void 0 && _m$items.length && !firstStepN) {
      firstStepN = i;
    }
  });

  if (!firstStepN) {
    firstStepN = 1;
  }

  var menuPart1 = menu.slice(0, firstStepN);
  var menuPart2 = menu.slice(firstStepN).filter(function (m) {
    return !m.divider;
  });
  var title = translate((_data$settings = data.settings) === null || _data$settings === void 0 ? void 0 : (_data$settings$summar = _data$settings.summary_settings) === null || _data$settings$summar === void 0 ? void 0 : _data$settings$summar.summary_name);
  var description = translate((_data$settings2 = data.settings) === null || _data$settings2 === void 0 ? void 0 : (_data$settings2$summa = _data$settings2.summary_settings) === null || _data$settings2$summa === void 0 ? void 0 : _data$settings2$summa.summary_description);
  var projectTitle = translate((_data$settings3 = data.settings) === null || _data$settings3 === void 0 ? void 0 : (_data$settings3$basic = _data$settings3.basic_settings) === null || _data$settings3$basic === void 0 ? void 0 : _data$settings3$basic.name);
  var projectDescription = translate((_data$settings4 = data.settings) === null || _data$settings4 === void 0 ? void 0 : (_data$settings4$basic = _data$settings4.basic_settings) === null || _data$settings4$basic === void 0 ? void 0 : _data$settings4$basic.description);
  var projectAddress = translate((_data$settings5 = data.settings) === null || _data$settings5 === void 0 ? void 0 : (_data$settings5$proje = _data$settings5.project_settings) === null || _data$settings5$proje === void 0 ? void 0 : _data$settings5$proje.project_address);
  var summaryContactTitle = translate((_data$settings6 = data.settings) === null || _data$settings6 === void 0 ? void 0 : (_data$settings6$summa = _data$settings6.summary_settings) === null || _data$settings6$summa === void 0 ? void 0 : _data$settings6$summa.summary_contact_name);
  var projectContactPerson = translate((_data$settings7 = data.settings) === null || _data$settings7 === void 0 ? void 0 : (_data$settings7$proje = _data$settings7.project_settings) === null || _data$settings7$proje === void 0 ? void 0 : _data$settings7$proje.project_contact_person);
  var projectContactPhone = translate((_data$settings8 = data.settings) === null || _data$settings8 === void 0 ? void 0 : (_data$settings8$proje = _data$settings8.project_settings) === null || _data$settings8$proje === void 0 ? void 0 : _data$settings8$proje.project_contact_phone);
  var projectContactEmail = translate((_data$settings9 = data.settings) === null || _data$settings9 === void 0 ? void 0 : (_data$settings9$proje = _data$settings9.project_settings) === null || _data$settings9$proje === void 0 ? void 0 : _data$settings9$proje.project_contact_email);
  var summarySaveOptionsTitle = translate((_data$settings10 = data.settings) === null || _data$settings10 === void 0 ? void 0 : (_data$settings10$summ = _data$settings10.summary_settings) === null || _data$settings10$summ === void 0 ? void 0 : _data$settings10$summ.summary_save_options_name);
  var foundingTitle = translate((_data$settings11 = data.settings) === null || _data$settings11 === void 0 ? void 0 : (_data$settings11$summ = _data$settings11.summary_settings) === null || _data$settings11$summ === void 0 ? void 0 : _data$settings11$summ.summary_founding_name);
  var foundingDescription = translate((_data$settings12 = data.settings) === null || _data$settings12 === void 0 ? void 0 : (_data$settings12$summ = _data$settings12.summary_settings) === null || _data$settings12$summ === void 0 ? void 0 : _data$settings12$summ.summary_founding_description);
  var model = configuration !== null && configuration !== void 0 && configuration.selectedModel && (_data$models = data.models) !== null && _data$models !== void 0 && _data$models.length ? data.models.find(function (model) {
    return model.key === configuration.selectedModel;
  }) : null;
  var collection = configuration !== null && configuration !== void 0 && configuration.selectedCollection && model !== null && model !== void 0 && (_model$collections = model.collections) !== null && _model$collections !== void 0 && _model$collections.length ? model.collections.find(function (collection) {
    return collection.key === configuration.selectedCollection;
  }) : null; //const selectedCollection = collection ? translate(collection.name) : configuration?.isCustomCollection ? translate(menus.collectionsMenuCustomSpan) : "";

  var url = externalSettings !== null && externalSettings !== void 0 && externalSettings.parentUrl ? externalSettings.parentUrl + routes.summaryRoute : req.wappRequest.protocol + "://" + req.wappRequest.hostname + req.wappRequest.path;
  var copyUrl = url + "/" + queryString;

  if (externalSettings.summaryConfigurationUrl) {
    copyUrl = externalSettings.summaryConfigurationUrl({
      queryString: queryString
    });
  }

  var mailto = "mailto:" + projectContactEmail + "?body=" + encodeURIComponent(copyUrl);
  var embedUrl = externalSettings !== null && externalSettings !== void 0 && externalSettings.embedUrl ? externalSettings.embedUrl + routes.summaryRoute + "?print=1" : req.wappRequest.protocol + "://" + req.wappRequest.hostname + req.wappRequest.path + "?print=1";
  var printNewPage = embedUrl !== url + "?print=1";
  var printUrl = printNewPage ? embedUrl + "&" + queryString.slice(1) : null;
  var copyTextRef = (0, _react.useRef)();

  function copyToClipboard() {
    var copyText = copyTextRef.current;
    copyText.focus();
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    document.execCommand("copy");
    copyText.blur();
  }

  function print(e) {
    if (e) {
      e.preventDefault();
    }

    var tempScrollY = 0;

    function afterPrint() {
      var query = req.wappRequest.query;
      var redirect = query.print ? req.wappRequest.path : null;
      var close = !!query.print;
      window.removeEventListener("afterprint", afterPrint, true);

      if (close) {
        window.close();
        return;
      }

      if (redirect) {
        wapp.client.history.push((0, _objectSpread2["default"])({
          search: "",
          hash: ""
        }, wapp.client.history.parsePath(redirect)));
        return;
      }

      if (tempScrollY) {
        window.scrollTo(0, tempScrollY);
      }
    }

    window.addEventListener("afterprint", afterPrint, true);

    if (window.scrollY !== 0) {
      tempScrollY = window.scrollY;
      window.scrollTo(0, 0);
    }

    window.print();
  }

  var printButton = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    var timeout = setTimeout(function () {
      var query = req.wappRequest.query;

      if (query.print) {
        var evObj = document.createEvent("Events");
        evObj.initEvent("click", true, false);
        printButton.current.dispatchEvent(evObj);
      }
    }, 100);
    return function () {
      clearTimeout(timeout);
    };
  }, [req.wappRequest.query, printButton]);
  var hideModels = ((_data$models2 = data.models) === null || _data$models2 === void 0 ? void 0 : _data$models2.length) === 1 && model && data.models[0].key === model.key || !data.models || data.models && data.models.length === 0;
  var hideCollections = !model || model && !model.collections || model && model.collections && model.collections.length === 0 || model && model.collections && model.collections.length === 1;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(materialStyle.summary, style.summary, (0, _defineProperty2["default"])({}, style.narrow, narrow)),
    ref: container
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.projectContainer
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.homeContentOnPrint
  }, /*#__PURE__*/_react["default"].createElement(_Home["default"], {
    print: true
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: style.projectTextsContainer
  }, projectTitle ? /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "h5",
    className: style.title
  }, projectTitle) : null, projectAddress ? /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body2",
    color: "textSecondary",
    className: style.address
  }, projectAddress) : null, projectDescription ? /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body2",
    color: "textSecondary",
    className: style.description
  }, projectDescription) : null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: style.textContainer
  }, title ? /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "h5",
    className: style.title
  }, title) : null, model !== null && model !== void 0 && (_model$gallery = model.gallery) !== null && _model$gallery !== void 0 && _model$gallery.length ? /*#__PURE__*/_react["default"].createElement("div", {
    className: style.gallery
  }, /*#__PURE__*/_react["default"].createElement(_Gallery["default"], {
    gallery: (0, _toConsumableArray2["default"])(model.gallery_index_for_summary && model.gallery[model.gallery_index_for_summary] ? [model.gallery[model.gallery_index_for_summary]].concat((0, _toConsumableArray2["default"])(model.gallery.filter(function (g, i) {
      return i !== model.gallery_index_for_summary;
    }))) : model.gallery)
  })) : null, translate(model === null || model === void 0 ? void 0 : model.name) && !hideModels ? /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "h6",
    className: style.title
  },
  /*(selectedCollection) ? translate(model?.name) + " - " + selectedCollection : translate(model?.name)*/
  translate(model === null || model === void 0 ? void 0 : model.name)) : null, translate(model === null || model === void 0 ? void 0 : model.description) && !hideModels ? /*#__PURE__*/_react["default"].createElement("div", {
    className: style.paragraph
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body2",
    color: "textSecondary",
    className: style.description
  }, translate(model === null || model === void 0 ? void 0 : model.description))) : null, translate(collection === null || collection === void 0 ? void 0 : collection.description) && !hideModels && !hideCollections ? /*#__PURE__*/_react["default"].createElement("div", {
    className: style.paragraph
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body2",
    color: "textSecondary",
    className: style.description
  }, translate(collection === null || collection === void 0 ? void 0 : collection.description))) : null), /*#__PURE__*/_react["default"].createElement("div", {
    className: style.table
  }, /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
    menu: menuPart1,
    list: true,
    menuKey: "summary_menu_1"
  })), menuPart2.length ? menuPart2.map(function (stepMenu, i) {
    var _stepMenu$items, _model$steps, _step$layer, _stepMenu$items2;

    var isAStep = (_stepMenu$items = stepMenu.items) === null || _stepMenu$items === void 0 ? void 0 : _stepMenu$items.length;
    var step = isAStep && model !== null && model !== void 0 && (_model$steps = model.steps) !== null && _model$steps !== void 0 && _model$steps.length ? model.steps.find(function (step, si) {
      return i === si;
    }) : null;
    var stepName = step !== null && step !== void 0 && step.name ? translate(step.name) : "";
    var layers = step !== null && step !== void 0 && (_step$layer = step.layer) !== null && _step$layer !== void 0 && _step$layer.length ? [step.layer].concat((0, _toConsumableArray2["default"])(Object.keys(configuration.steps[step.key]).filter(function (questionKey) {
      var _configuration$steps$;

      return (_configuration$steps$ = configuration.steps[step.key][questionKey].layer) === null || _configuration$steps$ === void 0 ? void 0 : _configuration$steps$.length;
    }).map(function (questionKey) {
      return configuration.steps[step.key][questionKey].layer;
    }))) : [];
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx3["default"])(style.table, (0, _defineProperty2["default"])({}, style.oneColumn, !layers.length)),
      key: "summary_menu_" + i
    }, stepName ? /*#__PURE__*/_react["default"].createElement("div", {
      className: style.tableTitle
    }, stepName) : null, /*#__PURE__*/_react["default"].createElement("div", {
      className: style.tableContent
    }, layers.length ? /*#__PURE__*/_react["default"].createElement("div", {
      className: style.tableLeft
    }, /*#__PURE__*/_react["default"].createElement(_Layers["default"], {
      layers: layers,
      dayPeriod: "day"
    })) : null, /*#__PURE__*/_react["default"].createElement("div", {
      className: style.tableRight
    }, /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
      menu: (0, _toConsumableArray2["default"])((_stepMenu$items2 = stepMenu.items) !== null && _stepMenu$items2 !== void 0 && _stepMenu$items2.length ? stepMenu.items : [stepMenu]),
      list: true,
      menuKey: "summary_menu_" + i
    }))));
  }) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.textContainer
  }, description ? /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body2",
    color: "textSecondary",
    className: style.description
  }, description) : null), /*#__PURE__*/_react["default"].createElement("div", {
    className: style.foundingContainer
  }, foundingTitle ? /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "h5",
    className: style.title
  }, foundingTitle) : null, foundingDescription ? /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body2",
    color: "textSecondary",
    className: style.description
  }, foundingDescription) : null), /*#__PURE__*/_react["default"].createElement("div", {
    className: style.summaryFooter
  }, projectContactPerson || projectContactEmail || projectContactPhone ? /*#__PURE__*/_react["default"].createElement("div", {
    className: style.listContainer
  }, summaryContactTitle ? /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "h5",
    className: style.title
  }, summaryContactTitle) : null, /*#__PURE__*/_react["default"].createElement(_List["default"], {
    className: style.list
  }, projectContactPerson ? /*#__PURE__*/_react["default"].createElement(_ListItem["default"], null, /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], {
    className: materialStyle.listItemIcon
  }, /*#__PURE__*/_react["default"].createElement(_Person["default"], null)), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
    primary: projectContactPerson
  })) : null, projectContactPhone ? /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
    button: true,
    component: "a",
    target: "_self",
    href: "tel:" + projectContactPhone
  }, /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], {
    className: materialStyle.listItemIcon
  }, /*#__PURE__*/_react["default"].createElement(_Phone["default"], null)), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
    primary: projectContactPhone
  })) : null, projectContactEmail ? /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
    button: true,
    component: "a",
    target: "_self",
    href: mailto,
    key: Date.now()
  }, /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], {
    className: materialStyle.listItemIcon
  }, /*#__PURE__*/_react["default"].createElement(_Email["default"], null)), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
    primary: projectContactEmail
  })) : null)) : null, copyUrl ? /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.listContainer, style.summarySave)
  }, summarySaveOptionsTitle ? /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "h5",
    className: style.title
  }, summarySaveOptionsTitle) : null, /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
    type: "text",
    value: copyUrl,
    onChange: function onChange() {
      return copyUrl;
    },
    inputProps: {
      ref: copyTextRef
    },
    className: style.copyUrlInput
  }), /*#__PURE__*/_react["default"].createElement(_List["default"], {
    className: style.list
  }, /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
    button: true,
    onClick: function onClick(e) {
      return copyToClipboard(e);
    },
    key: Date.now() + 1
  }, /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], {
    className: materialStyle.listItemIcon
  }, /*#__PURE__*/_react["default"].createElement(_FileCopy["default"], null)), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
    primary: translate(labels.copyUrlToClipboardLabel)
  })), /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
    ref: printButton,
    button: true,
    component: printNewPage ? "a" : null,
    href: printNewPage ? printUrl : null,
    target: printNewPage ? "_blank" : null,
    onClick: !printNewPage ? print : null,
    key: Date.now() + 2
  }, /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], {
    className: materialStyle.listItemIcon
  }, /*#__PURE__*/_react["default"].createElement(_Print["default"], null)), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
    primary: translate(labels.printLabel)
  })))) : null, QRCodeUrl ? /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.listContainer, style.QRCodeContainer)
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: QRCodeUrl,
    className: style.QRCodeImage,
    alt: "qrcode"
  })) : null, QRCodeUrl ? /*#__PURE__*/_react["default"].createElement("div", {
    className: style.QRCodeContainerOnPrint
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: QRCodeUrl,
    className: style.QRCodeImage,
    alt: "qrcode"
  })) : null));
}

var WappComponent = (0, _Wapp.withWapp)(Summary);
var StyledComponent = (0, _withMaterial.withMaterialStyles)(_materialStyle["default"], WappComponent);
var _default = StyledComponent;
exports["default"] = _default;